module.exports = {
  webapi: process.env.REACT_APP_WEBAPI_URL || 'http://localhost:3000',
  cloudApi: process.env.REACT_APP_CLOUD_API || 'http://localhost:8081',
  posAdmin: process.env.REACT_APP_POS_ADMIN_URL || 'http://localhost:3001',
  dataopsapi: process.env.REACT_APP_DATAOPSAPI_URL || 'http://localhost:5000',
  loyaltyApi:
    process.env.REACT_APP_LOYALTY_PLATFORM_API || 'http://localhost:3000'
};
